import styled from 'styled-components'

import { breakpoints, colors, fontSizes } from '@/styles'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${breakpoints.desktop}) {
    flex-direction: column;
    flex: 1;
  }
`
const Left = styled.div`
  display: grid;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
  background: ${colors.white};
  height: 100vh;
  padding: 40px 72px;
  @media screen and (max-width: ${breakpoints.desktop}) {
    flex: 0;
    height: fit-content;
    padding: 40px;
    width: 100%;
    justify-content: flex-start;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 16px;
  }
`
const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  background: ${colors.blue96};
  min-height: 100vh;
  padding: 72px;
  @media screen and (max-width: ${breakpoints.desktop}) {
    width: 100%;
    flex: 3;
    align-items: flex-start;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 0;
  }
`
const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 32px;
  flex: 1;
  gap: 32px;
  border-radius: 8px;
  background: ${colors.white};
  min-height: fit-content;

  overflow-y: scroll;
  max-width: 560px;
  min-width: 520px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 0;
    min-width: 0;
    border-radius: 0;
  }
`

const CardTitle = styled.h3`
  font-size: 18px;
  padding: 0 10px;
  text-align: left;
  width: 100%;
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 0 16px;
    font-size: ${fontSizes.medium};
  }
`

const Title = styled.h1`
  font-size: 40px;
  font-weight: 700;
  max-width: 520px;
  line-height: 44px;

  @media screen and (max-width: ${breakpoints.desktop}) {
    font-size: 34px;
    max-width: none;
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: 30px;
    line-height: 32px;
  }
`

const Subtitle = styled.span`
  font-size: 20px;
  font-weight: 400;

  @media screen and (max-width: ${breakpoints.desktop}) {
    font-size: 19px;
    max-width: 300px;
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: 16px;
  }
`
const LogoWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`

const LoginWrapper = styled.div`
  font-size: 16px;
  font-weight: 400;
  margin-top: 32px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: 14px;
    margin-top: 16px;
  }

  a {
    font-weight: 500;
    text-decoration: none;
    color: ${colors.link};
    cursor: pointer;
  }
`

export {
  Wrapper,
  Left,
  Right,
  FormWrapper,
  CardTitle,
  Title,
  Subtitle,
  LogoWrapper,
  LoginWrapper
}
